import React, { Component } from 'react';
import { connect } from 'react-redux';
import EmailSubscriptionsView from '../components/views/EmailSubscriptions';
import { withRouter } from '../helpers/withRouter';
import { closeModal, openModal, updateEmailSubscriptions } from '../redux/actions';
import type { EmailSubscriptionsProps, SingleModalState, State } from '../types';

class EmailSubscriptions extends Component<EmailSubscriptionsProps> {
  render(): React.ReactNode {
    return (
      <EmailSubscriptionsView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  subscriptions: state.subscriptions,
});

const mapDispatchToProps = dispatch => ({
  onUpdateEmailSubscriptions: (subscriptions: any) => dispatch(updateEmailSubscriptions(subscriptions)),
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
});

const ConnectedEmailSubscriptions = withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailSubscriptions as any));

export default ConnectedEmailSubscriptions;
